<p>
	<label class="{{labelClass}}" [attr.for]="'inputText_' + randomId">{{labelInput}}
		<span class="sr-only" *ngIf="highlight">{{highlightLabel}}</span>
		<span class="sr-only" *ngIf="infotext">{{infotext}}</span>
	</label>
	<span *ngIf="mandatory" class="mandatory">*</span>
	<span *ngIf="infotext" class="glyphicon glyphicon-info-sign" [tooltip]="infotext"></span>
	<input [attr.name]="name" [attr.id]="'inputText_' + randomId" #dinput cleanInput [class]="'form-control' + getHighlight()" [attr.autocomplete]="autocomplete" maxlength="{{maxLength}}"
		[attr.aria-describedby]="'errorMessage_' + randomId" type='text'
		[placeholder]="submitPending ? '' : 'Inserire '+labelInput" [(ngModel)]="_value" [disabled]="submitPending"
		[attr.aria-required]="mandatory" (ngModelChange)="onChange($event)" />
	<small style="color:#e60000;" aria-live="assertive" aria-atomic="true" id="errorMessage_{{randomId}}">&nbsp;
		<ng-template [ngIf]="control && !control.valid && checkFormat && _value">
			Formato non valido
		</ng-template>
	</small>
</p>
